// Free-shipping messaging: keeps the sticky strip and the cart progress bar in
// sync with the cart, and keeps the strip below the category belt when the
// belt pins to the top.
//
// The strip lives outside every cart section, so nothing re-renders it on a
// cart change. It listens to Dawn's cartUpdate pub/sub and, as a safety net
// for code paths that mutate the cart without publishing, watches fetch calls
// to the /cart/ endpoints.
//
// The cart bar is server-rendered by its own section, but with fallback
// amounts: Liquid cannot read the "Envío gratis" section's settings from
// inside the cart, so the real thresholds arrive here in the config blob and
// this script rewrites the bar. When the amounts have not been changed both
// renders agree and the rewrite is a no-op.
(function () {
  var configEl = document.querySelector('[data-kstrip-config]');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var std = parseInt(config.std, 10) || 0;
  var exp = parseInt(config.exp, 10) || 0;
  if (exp < std) exp = std;

  var strip = document.querySelector('[data-kstrip]');
  var textEl = strip && strip.querySelector('[data-kstrip-text]');
  var t = config.strip || {};
  var tBar = config.bar || {};

  // Shopify money format, e.g. "$ {{amount}}" - render cents with the store's
  // own template instead of hardcoding a currency.
  var format = config.moneyFormat || '${{amount}}';
  // keepZeros mirrors `money`; without it, `money_without_trailing_zeros`.
  // The strip drops ".00", the cart bar keeps it, same as their Liquid.
  var money = function (cents, keepZeros) {
    var round = !keepZeros && cents % 100 === 0;
    var amount = round ? (cents / 100).toFixed(0) : (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  };

  // Which tier the cart is working toward. Shared by both surfaces so they can
  // never disagree about the state, only about how they word it.
  var tierFor = function (cart) {
    var total = cart.total_price;
    // A cart with nothing that ships (event seats only) has no shipping step,
    // so it gets the general promo instead of free-shipping progress.
    var ships = (cart.items || []).some(function (item) { return item.requires_shipping; });
    if (cart.item_count === 0 || !ships) return { state: 'promo', remaining: 0, percent: 0 };
    if (total < std) {
      return { state: 'toward-std', remaining: std - total, percent: std ? (total * 100) / std : 0 };
    }
    if (total < exp) {
      return { state: 'toward-exp', remaining: exp - total, percent: exp ? (total * 100) / exp : 0 };
    }
    return { state: 'all-free', remaining: 0, percent: 100 };
  };

  // The strip's message MUST come from the config, never read back from the
  // DOM. Reading it back captured whatever state the page happened to render
  // with: land on a page while the cart is already over a threshold and the
  // "empty cart" message would be stored as "free express unlocked", then
  // restored verbatim once the cart emptied. That only showed up after
  // navigating, which is what made it look intermittent.
  var renderStrip = function (tier) {
    if (!strip) return;
    strip.className = 'kstrip kstrip--' + tier.state;
    if (!textEl) return;

    // Plain string: the translation template already wraps it in a pill span,
    // wrapping again nested one pill inside another.
    var amount = money(tier.remaining);
    if (tier.state === 'promo') textEl.innerHTML = t.promo || '';
    else if (tier.state === 'toward-std') textEl.innerHTML = (t.std || '').replace('@@AMOUNT@@', amount);
    else if (tier.state === 'toward-exp') textEl.innerHTML = (t.exp || '').replace('@@AMOUNT@@', amount);
    else textEl.innerHTML = t.done || '';
  };

  var renderBars = function (tier) {
    var bars = document.querySelectorAll('[data-kfship]');
    // 'promo' = empty cart or nothing that ships: the server does not render
    // the bar then, but a bar left over from before the change must hide too.
    for (var b = 0; b < bars.length; b++) bars[b].hidden = tier.state === 'promo';
    if (!bars.length || tier.state === 'promo') return;
    var amount = money(tier.remaining, true);
    var html;
    if (tier.state === 'toward-std') {
      html = (tBar.std || '').replace('@@AMOUNT@@', amount);
    } else if (tier.state === 'toward-exp') {
      html =
        '<span class="kfship__won">' +
        (tBar.wonStd || '') +
        '</span> ' +
        (tBar.exp || '').replace('@@AMOUNT@@', amount);
    } else {
      html = '<span class="kfship__won">' + (tBar.done || '') + '</span>';
    }

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      bar.className = 'kfship kfship--' + tier.state;
      var barText = bar.querySelector('[data-kfship-text]');
      if (barText) barText.innerHTML = html;
      var fill = bar.querySelector('[data-kfship-fill]');
      if (fill) fill.style.width = Math.min(100, Math.round(tier.percent)) + '%';
    }
  };

  var render = function (cart) {
    var tier = tierFor(cart);
    renderStrip(tier);
    renderBars(tier);
  };

  var refresh = function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }

  // Self-correct on arrival: the server-rendered state can be stale when the
  // HTML comes from a cache, the back/forward cache, or another tab changed
  // the cart. One cheap request keeps both surfaces honest.
  refresh();
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refresh();
  });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });

  // Safety net: any cart mutation refreshes, even from code that does not
  // publish the event (our quick-add, third-party apps). It also covers the
  // cart bar being re-rendered by the Section Rendering API, which brings back
  // the server's fallback amounts.
  var nativeFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = nativeFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      promise.then(function () { setTimeout(refresh, 60); }).catch(function () {});
    }
    return promise;
  };

  // Sit below the belt while it is pinned; the belt's height is only known
  // once it sticks, so track it instead of hardcoding an offset. The custom
  // property goes on the root because what sticks is the section wrapper, not
  // the strip itself.
  var belt = document.querySelector('.collection-filter__belt');
  if (belt && strip) {
    var place = function () {
      var offset = belt.classList.contains('is-stuck') ? belt.offsetHeight : 0;
      document.documentElement.style.setProperty('--kstrip-top', offset + 'px');
    };
    place();
    new MutationObserver(place).observe(belt, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', place);
    window.addEventListener('scroll', place, { passive: true });
  }
})();
